"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureMiddlewares = exports.coreMiddlewares = void 0;
const filters_middleware_1 = require("./feature/filters.middleware");
const actionSplitter_1 = require("./core/actionSplitter");
const vehicles_middleware_1 = require("./feature/vehicles.middleware");
const featureMiddlewares = [filters_middleware_1.filtersMiddleware, vehicles_middleware_1.vehiclesMiddleware];
exports.featureMiddlewares = featureMiddlewares;
const coreMiddlewares = [actionSplitter_1.actionSplitterMiddleware];
exports.coreMiddlewares = coreMiddlewares;
//# sourceMappingURL=index.js.map